export const GET_USER = "GET_USER";
export const GET_USERS = "GET_USERS";
export const POST_CREATE_USER = "POST_CREATE_USER";
export const PUT_UPDATE_USER = "PUT_UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
